import React, {Component} from 'react';

import './TaxonomyList.css';

class TaxonomyList extends Component {
	render() {
		return (
			<section className={`TaxonomyList ${this.props.className || ''}`}>
				<ol>{this.props.children}</ol>
			</section>
		);
	}
}

export default TaxonomyList;



// WEBPACK FOOTER //
// ./src/widgets/TaxonomyList.js